import api from "./axios";
// =============================================================================
// BOOKING API
// =============================================================================
/**
 * Org scoping is entirely via the X-Org-Id header (default orgContext:
 * "tenant" behavior) — the route has no /organizations/:orgId/ segment.
 */
export const bookingApi = {
    list(params = {}) {
        return api.get("/api/v2/bookings", { params, orgContext: "tenant" });
    },
    getById(bookingId) {
        return api.get(`/api/v2/bookings/${encodeURIComponent(bookingId)}`, {
            orgContext: "tenant",
        });
    },
};
export default bookingApi;
